import styles from './ErrorMessage.module.css'

const ErrorMessage = () => {
  return (
    <p className={styles.text}>Oops... Something went wrong... Try again later</p>
  )
}

export default ErrorMessage